import React from 'react';
import { Reveal } from './Reveal';
export function Guarantee() {
  return <section className="bg-ink px-6 py-20 text-center" data-id="element-63" data-mp="1o3najtayw8to">
      <Reveal data-id="element-64" data-mp="1o33s8bhenif4">
        <svg viewBox="0 0 140 140" className="mx-auto h-36 w-36" role="img" aria-label="Sello de garantía de 7 días" data-id="element-65" data-mp="1o5q2iivokc11">
          <circle cx="70" cy="70" r="66" fill="none" stroke="#D4AF37" strokeWidth="1.5" data-id="element-66" data-mp="1x4bs2xzkkrbb" />
          <circle cx="70" cy="70" r="59" fill="none" stroke="#D4AF37" strokeWidth="1" data-id="element-67" data-mp="1x2ilfioyi73b" />
          <text x="70" y="76" textAnchor="middle" fill="#D4AF37" fontFamily="'Playfair Display', serif" fontWeight="700" fontSize="30" data-id="element-68" data-mp="19co8l14n0ij2">
            7 DÍAS
          </text>
          <text x="70" y="97" textAnchor="middle" fill="#CFCFCF" fontFamily="Inter, sans-serif" fontWeight="600" fontSize="9" letterSpacing="3" data-id="element-69" data-mp="1ed25bn0sg61s">
            GARANTÍA
          </text>
        </svg>
        <h2 className="mt-8 font-serif text-[32px] font-bold leading-tight text-white" data-id="element-70" data-mp="oyqewbuo01kq">Tu riesgo es cero.</h2>
        <p className="mt-5 text-base leading-relaxed text-muted" data-id="element-71" data-mp="tx1oclh1sa2f">
          Tienes 7 días de garantía incondicional por Hotmart. Si sientes que Elegida no es para ti, pides tu
          reembolso y se te devuelve el 100% de tu dinero. Sin preguntas.
        </p>
      </Reveal>
    </section>;
}